import { render, staticRenderFns } from "./FilmTabs.vue?vue&type=template&id=2f6670e0&scoped=true&"
import script from "./FilmTabs.vue?vue&type=script&lang=js&"
export * from "./FilmTabs.vue?vue&type=script&lang=js&"
import style0 from "./FilmTabs.vue?vue&type=style&index=0&id=2f6670e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6670e0",
  null
  
)

component.options.__file = "FilmTabs.vue"
export default component.exports